export default __webpack_public_path__ + "static/media/instagram-incon__grey.fa9ae836.svg";